import { googleAuthCodeLogin } from 'vue3-google-login'
import config from '@/utils/config'
import { COOKIE_OPTIONS_SUFFIX } from "@/utils/cookieConfig";
import { googleLinkedInLogin, keyCloakLogin, userLogin } from '../apiFunction'
const sign = require('jwt-encode')
const qs = require('qs')
export default {
  methods: {
    googleLogin(newlogin) {
      googleAuthCodeLogin()
        .then((response) => {
          console.log('Handle the response', response.code)
          const code = response.code
          this.show = true
          const jwt = this.createjwtToken(code)
          this.ssoLogin(jwt, code, 'google', newlogin)
        })
        .catch((error) => {
          console.error('Web Google Sign-In error:', error)
          this.setNoAccess('Google Sign-In failed. Please try again.')
          if (this.$store) {
            this.$store.commit('userVUEX/setProfileProgress', false)
          }
        })
    },
    createjwtToken(token) {
      const secret = token
      const data = {
        exp: Math.floor(Date.now() / 1000) + 60 * 60,
        sub: token,
      }
      const jwt = sign(data, secret, { algorithm: 'RS256' })
      console.log(jwt, 'jwt 1174')
      return jwt
    },
    async ssoLogin(tokenval, authtoken, type, newlogin) {
      try {
        let payload = {
          token: authtoken,
          authType: type,
          origin: window.location.origin
        }
        console.log(tokenval, 'tokenval', payload, 'payload')
        const resp = await googleLinkedInLogin(payload, tokenval)
        if (resp.status == 200) {
          // this.googleSignIn = false;
          if (newlogin) {
            this.$store.commit('userVUEX/setToken', resp.data.data.access_token)
            this.$store.commit(
              'userVUEX/setRefreshToken',
              resp.data.data.refresh_token,
            )
          }
          if (newlogin)
            this.getProjectsData(
              'candidate',
              false,
              resp.data.data.access_token,
              'google',
            )
          else {
            this.getProjects(
              resp.data.data.access_token,
              resp.data.data.logged_in,
              resp.data.data.refresh_token,
            )
          }
        }
        //
        else {
          this.setNoAccess('Invalid credentials.')
        }
      } catch (error) {
        this.setNoAccess('Login failed.')
      }
    },
    async getProjects(accessToken, type, refreshToken, win) {
      try {
        const res = await keyCloakLogin(accessToken)
        if (res.status == 200) {
          let projects = res.data.details.filter((obj) => {
            let val = obj.userPermissions
              ? obj.userPermissions.isActive
              : obj.isActive
            if (val) return obj
          })
          let loginData = {
            showPreference: false,
          }
          if (type && type == 'google') {
            loginData.logged_in = 'google'
          }
          this.setCookie('accessToken', accessToken)
          this.setCookie('refreshToken', refreshToken)
          this.setCookie('loginData', JSON.stringify(loginData))
          let projectMap = {}
          let totalProjects = [
            'assessment',
            'recruitment',
            'candidate',
            'training',
            'collegeDashboard',
          ]
          projects.forEach((item) => {
            if (item.project) {
              projectMap[item.project] = item
            }
          })

          totalProjects.forEach((projectName) => {
            if (projectMap[projectName]) {
              this.setCookie(
                projectName,
                JSON.stringify(projectMap[projectName]),
              )
            } else {
              this.setCookie(projectName, 'no-access')
            }
          })

                    if (win) {
                        win.location.href = `${config.candidateBase}/?from=candidate`;
                    } else {
                        // fallback if popup was blocked
                        window.open(`${config.candidateBase}/?from=candidate`);
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        setCookie(name, value) {
            // document.cookie = `${name}=${value}; expires=Wed, 14 Jan 2026 12:00:00 UTC; path=/;`;
            document.cookie = `${name}=${value}; ${COOKIE_OPTIONS_SUFFIX}` ;
        },

        async goToLogin() {
            try {
                let userDetails = {
                    keycloak: qs.stringify({
                        grant_type: "password",
                        client_id: "vue-test-app",
                        username: this.email.trim(),
                        password: this.password.trim(),
                    }),
                };
                const response = await userLogin(userDetails.keycloak);
                if (response.status == 200) {
                    this.getProjects(response.data.access_token, false, response.data.refresh_token)
                }
            } catch (error) {
                console.error(error);
            }
        },
        getToken() {
            if (document.cookie.length > 0) {
                let data = document.cookie.split(";");
                for (let i in data) {
                    let cur = data[i].split("=");
                    if (cur[0].trim() === "accessToken") {
                        return cur[1];
                    }
                }
            }
            return null;
        },
    }
}
